export function throttle(fn: () => void, ms: number): (() => void) & { cancel(): void } {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let pending = false;

  function flush() {
    timer = undefined;
    if (pending) {
      pending = false;
      fn();
      timer = setTimeout(flush, ms);
    }
  }

  const throttled = () => {
    if (timer === undefined) {
      fn();
      timer = setTimeout(flush, ms);
    } else {
      pending = true;
    }
  };

  throttled.cancel = () => {
    if (timer !== undefined) {
      clearTimeout(timer);
      timer = undefined;
    }
    pending = false;
  };

  return throttled;
}
